import Vue from 'vue';
import Router from 'vue-router';
import config from '@/utils/config';

import SignIn from '@/pages/SignIn';
import PasswordReset from '@/pages/PasswordReset';
import EmailVerification from '@/pages/EmailVerification';
import Profile from '@/pages/Profile';
import UserList from '@/pages/UserList';
import RoleList from '@/pages/RoleList';
import LogList from '@/pages/LogList';
import DealerList from '@/pages/DealerList';
import EmailList from '@/pages/EmailList';
import TemplateList from '@/pages/TemplateList';
import AARList from '@/pages/AARList';
import AARItem from '@/pages/AARItem';
import store from '../store';

Vue.use(Router);

const redirectIfNotAuthorized = (to, from, next) => {
  if (!localStorage.jwtacc) {
    next('/sign-in');
    return;
  }

  if (to.meta.interface && !store.state.user.interfaces.filter(it => to.meta.interfaces.includes(it))) {
    next('/');
    return;
  }

  next();
};

const redirectIfAuthorized = (to, from, next) => {
  if (localStorage.jwtacc) {
    next('/');
    return;
  }
  next();
};

const router = new Router({
  mode: 'history',
  base: config.CONTAINER_NAME,

  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.name !== from.name) {
      return { y: 0 };
    }
  },
  routes: [
    {
      path: '/sign-in',
      name: 'SignIn',
      component: SignIn,
      beforeEnter: redirectIfAuthorized,
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
    },
    {
      path: '/password-reset',
      name: 'PasswordReset',
      component: PasswordReset,
      props: route => ({ resetCode: route.query.code }),
    },
    {
      path: '/email-verification',
      name: 'EmailVerification',
      component: EmailVerification,
      props: route => ({ verificationCode: route.query.code }),
    },
    {
      path: '/user-list',
      name: 'UserList',
      component: UserList,
      beforeEnter: redirectIfNotAuthorized,
    },
    {
      path: '/log-list',
      name: 'LogList',
      component: LogList,
      beforeEnter: redirectIfNotAuthorized,
      meta: {
        interfaces: ['UM-logs', 'UM-SVO-reports', 'readonly'],
      },
    },
    {
      path: '/role-list',
      name: 'RoleList',
      component: RoleList,
      beforeEnter: redirectIfNotAuthorized,
      meta: {
        interfaces: ['UM-role-edit'],
      },
    },
    {
      path: '/dealer-list',
      name: 'DealerList',
      component: DealerList,
      beforeEnter: redirectIfNotAuthorized,
      meta: {
        interfaces: ['UM-dealer-list'],
      },
    },
    {
      path: '/email-list',
      name: 'EmailList',
      component: EmailList,
      beforeEnter: redirectIfNotAuthorized,
      meta: {
        interfaces: ['UM-mail'],
      },
    },
    {
      path: '/template-list',
      name: 'TemplateList',
      component: TemplateList,
      beforeEnter: redirectIfNotAuthorized,
      meta: {
        interfaces: ['UM-mail-templates'],
      },
    },
    {
      path: '/aar-list',
      name: 'AARList',
      component: AARList,
      beforeEnter: redirectIfNotAuthorized,
      meta: {
        interfaces: ['UM-AAR'],
      },
    },
    {
      path: '/aar/:id',
      name: 'AARItem',
      component: AARItem,
      beforeEnter: redirectIfNotAuthorized,
      props: true,
    },
    {
      path: '*',
      redirect: '/user-list',
    },
  ],
});

router.beforeEach((to, from, next) => {
  store.commit('hideMenu');
  if (!localStorage.jwtacc && to.name !== 'SignIn' && !to.query.code) {
    next({
      path: '/sign-in',
      query: { redirect: to.fullPath },
    });
  } else {
    next();
  }
});

export default router;
